export default __webpack_public_path__ + "static/home-page-bio-1-a97889575cf1d63155abbb4ff02300a1.webp";